<template>
    <v-sheet>
        <time-info class="mb-20 mb-lg-40" />
        <time-btns class="mb-20 mb-lg-40" v-model="form" @input="emit" />
        <time-form class="mb-20 mb-lg-40" v-model="form" v-bind="{ program }" @input="emit" />
        <vertical-form-table v-model="form" v-bind="{ items }" @input="emit" />
    </v-sheet>
</template>

<script>
import { attrs_input } from "@/assets/variables/attrs";
import { initExpoEmployer, initExpoProgram } from "@/assets/variables/inits";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

import TimeInfo from "./time/time-info.vue";
import TimeBtns from "./time/time-btns.vue";
import TimeForm from "./time/time-form.vue";

const items = [
    {
        key: "interview.location",
        term: "면접장소",
        type: "text",

        required: true,
        placeholder: "면접장소를 입력하세요",
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        VerticalFormTable,

        TimeInfo,
        TimeBtns,
        TimeForm,
    },
    props: {
        value: { type: Object, default: initExpoEmployer }, // form
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        form: initExpoEmployer(),
        items,
    }),
    methods: {
        sync() {
            this.form = initExpoEmployer(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
